import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _reduce from "lodash/reduce";
import _map from "lodash/map";
import _isNil from "lodash/isNil";
import _find from "lodash/find";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
const isCorrect = (item, isOrdered, itemsSolution) => {
  const itemSolution = _find(itemsSolution, {
    id: item.id
  });
  if (_isNil(itemSolution)) {
    throw new Error("The item id ".concat(item.id, " doesn't exist in the solution environment"));
  }
  return item.offset === itemSolution.offset && item.target === itemSolution.target && (item.index === itemSolution.index || !isOrdered);
};
export const updateItemsStatus = (items, itemsSolution, isOrdered) => _map(items, item => _objectSpread(_objectSpread({}, item), {}, {
  status: isCorrect(item, isOrdered, itemsSolution) ? 'CORRECT' : 'INCORRECT'
}));
export const isItemsCorrect = (items, itemsSolution, isOrdered) => _reduce(items, (acc, item) => acc && isCorrect(item, isOrdered, itemsSolution), true);
export const getItemsSolution = (solution, items) => _reduce(solution, (acc, _ref) => {
  let {
    id,
    offset,
    target
  } = _ref;
  const item = _find(items, {
    id
  });
  if (_isNil(item)) {
    throw new Error("Cannot find the item with this id mentioned ".concat(id));
  }
  return acc.concat([_objectSpread(_objectSpread({}, item), {}, {
    id,
    offset,
    target
  })]);
}, []);